import https from "../repositories/https";
const resource = "/filter";

export default {
  fetchList(payload, config) {
    return https.post(`${resource}s.json`, payload, config);
  },
  createFilter(payload, config) {
    return https.post(`${resource}.json`, payload, config);
  },
  fetchFilter(filterId, config) {
    return https.get(`${resource}/${filterId}.json`, config);
  },
  updateFilter(filterId, payload, config) {
    return https.put(`${resource}/${filterId}.json`, payload, config);
  },
  deleteFilter(filterId, config) {
    return https.delete(`${resource}/${filterId}.json`, config);
  },
};
